module.exports = __webpack_public_path__ + "static/media/bg_pt-marcus_bg2.ac9e0f7a.png";